import React, { PropsWithChildren, Ref } from 'react';
import classnames from 'classnames';
import styles from './Paper.module.less';

type PaperProps = PropsWithChildren<{ className?: string }>;

const Paper = (props: PaperProps, forwardedRef?: Ref<any>) => {
  const { children, className, ...rest } = props;
  return (
    <div className={classnames(styles.paper, className)} ref={forwardedRef} {...rest}>
      {children}
    </div>
  );
};

export default React.forwardRef<any, PaperProps>(Paper);
